import React from 'react';
import { Award, Clock } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { formatDistanceToNow } from 'date-fns';
import { getNotificationIcon } from './NotificationUtils';
import type { NotificationItem } from '@/hooks/useNotifications';
import { cn } from '@/lib/utils';

interface BadgeNotificationItemProps {
  notification: NotificationItem;
  isUnread: boolean;
  onClose: () => void;
}

export function BadgeNotificationItem({ notification, isUnread, onClose }: BadgeNotificationItemProps) {
  const navigate = useNavigate();
  const { data } = notification;

  const handleClick = () => {
    navigate('/profile');
    onClose();
  };

  return (
    <div
      className={cn(
        "flex items-center gap-3 p-3 rounded-lg hover:bg-muted/50 transition-colors cursor-pointer",
        isUnread && "bg-primary/5 border-l-2 border-primary"
      )}
      onClick={handleClick}
    >
      <div className="h-12 w-12 rounded-full bg-yellow-100 dark:bg-yellow-900/20 flex items-center justify-center">
        <Award className="h-6 w-6 text-yellow-600 dark:text-yellow-400" />
      </div>
      
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2 mb-1">
          <div className="flex items-center gap-1">
            {getNotificationIcon('badge')}
            <p className={cn(
              "text-foreground",
              isUnread ? "font-semibold" : "font-medium"
            )}>
              You earned the "{data.badge_name}" badge!
            </p>
          </div>
        </div>
        {data.badge_description && (
          <p className="text-sm text-muted-foreground truncate">
            {data.badge_description}
          </p>
        )}
        <div className="flex items-center gap-2 text-sm text-muted-foreground mt-1">
          <Clock className="h-3 w-3" />
          <span>
            {formatDistanceToNow(new Date(notification.created_at), { addSuffix: true })}
          </span>
        </div>
      </div>
    </div>
  );
}
